<template>
  <filter-bar>
    <div class="md-layout-item md-size-15 md-medium-size-25 md-xsmall-size-100">
      <md-field>
        <label for="dateFrom">
          <md-icon>calendar_today</md-icon>
          <span v-show="!dateFrom">Desde</span>
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Desde"
          value-zone="America/Mexico_City"
          v-model="dateFrom"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateFrom = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>

    <div class="md-layout-item md-size-15 md-medium-size-25 md-xsmall-size-100">
      <md-field>
        <label for="dateOccurred">
          <md-icon>calendar_today</md-icon>
          {{ dateTo ? "" : "Hasta" }}
        </label>
        <datetime
          input-style="border: none; outline:none; width: 100%"
          type="date"
          title="Hasta"
          value-zone="America/Mexico_City"
          v-model="dateTo"
          :phrases="{ ok: '', cancel: '' }"
          auto
        ></datetime>
        <md-button class="md-simple md-just-icon" @click="dateTo = null">
          <md-icon>close</md-icon>
        </md-button>
      </md-field>
    </div>

    <div
      class="md-layout-item md-size-15 md-medium-size-40 md-xsmall-size-100"
      v-if="filterSinisterType"
    >
      <md-field>
        <label>Tipo de Siniestro</label>
        <md-select v-model="selectedJobType">
          <md-option :value="0">Todas</md-option>
          <md-option
            v-for="jobType in jobTypes"
            :key="jobType.id"
            :value="jobType.id"
          >{{ jobType.name }}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-15 md-medium-size-40 md-xsmall-size-100">
      <md-field>
        <label>Residente</label>
        <md-select v-model="selectedRevi">
          <md-option :value="0">Todos</md-option>
          <md-option v-for="revi in revis" :key="revi.id" :value="revi.id">{{ revi.name }}</md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-20 md-medium-size-50 md-xsmall-size-100">
      <md-field>
        <multiselect
          v-model="selectedHighway"
          v-bind="$attrs"
          multiple
          :options="highways"
          :limit="2"
          :max-height="250"
          track-by="id"
          label="name"
          placeholder="Seleccionar autopistas"
          deselect-label="Remover"
          select-label="Click para seleccionar"
          selected-label="Seleccionado"
          :limit-text="(count) => `y ${count} más`"
        >
          <template slot="beforeList">
            <div
              v-if="selectedHighway.length > 2"
              class="before-list-item"
              @click="clearAll"
            >Borrar selección</div>
          </template>
        </multiselect>
      </md-field>
    </div>
  </filter-bar>
</template>

<script>
import { Slider, Collapse } from "@/components";
import catalogService from "../../services/catalog";
import userService from "@/services/user";
import FilterBar from "@/components/FilterBar";
import sinisterService from "@/services/sinister";
import moment from "moment";

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },
  data() {
    const { dateFrom, dateTo } = this.defaults;

    return {
      dateFrom:
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom,
      dateTo: dateTo === undefined ? moment().format("YYYY-MM-DD") : dateTo,
      selectedHighway: [],
      highways: [],
      selectedJobType: null,
      jobTypes: [],
      selectedRevi: null,
      revis: [],
    };
  },
  created() {
    catalogService
      .fetch("highway", { noStore: true })
      .then((highways) => (this.highways = highways));
    sinisterService.fetchJobTypes().then((types) => (this.jobTypes = types));
    userService.fetchType("revi").then((users) => (this.revis = users));
    this.selectedJobType = 1;
  },
  props: {
    source: {
      type: Array,
      default: () => [],
    },
    dummyFilter: {
      type: Boolean,
      default: false,
    },
    filterSinisterType: {
      type: Boolean,
      default: true,
    },
    defaults: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    defaults(value) {
      const { dateFrom, dateTo } = value;
      this.dateFrom =
        dateFrom === undefined
          ? moment().subtract(15, "days").format("YYYY-MM-DD")
          : dateFrom;
      this.dateTo = dateTo;
    },
    filteredData() {
      this.$emit("filtered", this.filteredData);
    },
    dateFrom(value) {
      this.$emit("updateDateFrom", value || null);
    },
    dateTo(value) {
      this.$emit("updateDateTo", value || null);
    },
    selectedHighway(value) {
      this.$emit("updateSelectedHighway", value.map(({ id }) => id) || null);
    },
    selectedJobType(value) {
      this.$emit("updateSelectedJobType", value || null);
    },
    selectedRevi(value) {
      this.$emit("updateSelectedRevi", value || null);
    },
  },
  computed: {
    filteredData: function () {
      if (this.dummyFilter) {
        return this.source;
      }

      let dFrom = this.dateFrom;
      let dTo = this.dateTo;

      dFrom = dFrom && moment(dFrom);
      dTo = dTo && moment(dTo);
      const hi = this.selectedHighway;
      const job = this.selectedJobType;
      let filteredSource = this.source;

      if (dFrom) {
        filteredSource = filteredSource.filter((rS) =>
          rS.dateAssignment.isSameOrAfter(dFrom, "day")
        );
      }

      if (dTo) {
        filteredSource = filteredSource.filter((rS) =>
          rS.dateAssignment.isSameOrBefore(dTo, "day")
        );
      }

      if (hi) {
        filteredSource = filteredSource.filter((rS) => rS.highway == hi);
      }
      if (job) {
        filteredSource = filteredSource.filter((rS) => rS.job == job);
      }

      return filteredSource;
    },
  },
  methods: {
    clearAll() {
      this.selectedHighway = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}

.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.before-list-item {
  font-size: 1.6rem;
  padding: 8px 0px 8px 10px;
}
.before-list-item:hover {
  cursor: pointer !important;
  background-color: red;
  font-weight: bold;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/RoadSinisters/Filter.vue